/**
 * Where sign-in is allowed to send her afterwards.
 *
 * `/login?redirect=…` comes off the URL bar, so it is attacker-controlled: a
 * link like `/login?redirect=https://evil.example` would otherwise hand Omina
 * a working open redirect off the back of a real sign-in. Only same-origin
 * paths are accepted, and anything else silently becomes the dashboard.
 *
 * Rejected: absolute URLs ("https://…", "//host" — protocol-relative, which is
 * the one people forget), backslash variants that some parsers normalise to
 * slashes, and the login page itself (which would loop).
 */
export function safeRedirect(target: string | undefined, fallback = "/"): string {
  if (!target) return fallback;
  const value = target.trim();
  if (!value.startsWith("/")) return fallback;
  if (value.startsWith("//") || value.startsWith("/\\")) return fallback;
  if (value.startsWith("/login")) return fallback;
  return value;
}
